/* eslint-disable jquery/no-text */
/* eslint-disable max-len */
import $ from 'jquery';
import scrollTo from '../util/scrollTo';
import convertSizes from '../components/sizeConversions';
import { clientSideNav, NAV_EVENTS } from '../components/clientSideNav';
import { parseQueryString } from '../util/urlutils';
import {
  onEvent, isLG, isBackForwardNavigation, // eslint-disable-line import/named
} from '../util/domutils';
import throttle from '../components/throttle';
import gtmEvents from '../googleAnalytics/events';
import { enableSlideonPLPAltImg, EVENTS as TILE_EVENTS } from './productTile';

export const CONSTANTS = {
  LAST_VISITED_PRODUCT_KEY: '__tfg_lastpdp',
};

const CLASSES = {
  GRID_SIZE_SELECTOR: 'grid-size-selector',
  SORT_OPTIONS: 'sorting__toggle-section__btn',
  MOBILE_REFINE: 'mobilerefine',
};

const SELECTORS = {
  PAGE: '.paging__page',
  GRID_SIZE_SELECTOR: `.${CLASSES.GRID_SIZE_SELECTOR}`,
  SEARCH_CONTENT: '.search-content',
  PRODUCT_GRID: '.product-grid',
  PRODUCT_TILE: '.product-tile',
  PRODUCT_GRID_FOOTER: '.grid-footer',
  FILTER_TYPE: '.filters__filter',
  FILTER_VALUE: '.filters__value-link',
  FILTER_RESET: '.filters__reset-link',
  FILTER_REMOVE: '.filters__filter__applied__remove',
  PAGE_SIZE: '.page-size-options__item--link',
  LOAD_MORE: '.paging__next-btn',
  SORT_OPTIONS: `.${CLASSES.SORT_OPTIONS}`,
  SEARCH_RESULTS_CONTAINER: '.search-results-container',
  PRICE_REFINEMENT_FORM: '.filters__form--price',
  PRICE_REFINEMENT_INPUTS: '.filters__input--price',
  PRICE_REFINEMENT_MIN: '#filter-price-min',
  PRICE_REFINEMENT_MAX: '#filter-price-max',
  FILTERS_TOGGLE: '#filters-toggle',
  FILTERS_CONTAINER: '.filters-container',
  HORIZONTAL_FILTERS_CONTAINER: '.horizontal-filter-container',
  IMAGE_TOGGLE: '#image-switch',
  RESULTS_COUNT: '.search-results__count-row__count',
  UPDATED_RESULTS_COUNT: '.product-tiles__result-count',
  URL_INPUT: '.permalink',
  QS_INPUT: '.querystring',
};

const getPriceRefinementValues = () => {
  let min = 0;
  let max = 0;

  const minField = document.querySelector(SELECTORS.PRICE_REFINEMENT_MIN);
  const maxField = document.querySelector(SELECTORS.PRICE_REFINEMENT_MAX);

  if (minField && maxField) {
    min = minField.value;
    max = maxField.value;
  }

  return { min, max };
};

const mobileFilters = toggle => toggle.innerText.toLowerCase() === toggle.dataset.mobileText.toLowerCase();

let container = document.querySelector(SELECTORS.FILTERS_CONTAINER);
const horizontalContainer = document.querySelector(SELECTORS.HORIZONTAL_FILTERS_CONTAINER);
let filterBodies = container.querySelectorAll('.filters-container .filters__filter-body');
let filters = container.querySelectorAll('.filters__filter');
let dropdownBody = container.querySelectorAll('.filters__filter-body');
let breakpoint = window.innerWidth;

function updateHorizontalFilter(trigger, target) {
  if (isLG()) {
    filterBodies.forEach((filterBody) => {
      filterBody.dataset.parent = '#filter-container-accordion';
    });
    filters.forEach((item) => {
      item.classList.remove('card');
    });
    dropdownBody.forEach((dropdown) => {
      dropdown.classList.remove('show');
    });

    if (trigger && trigger.classList.contains('filters__value-link')) {
      const triggerID = trigger.closest('.filters__filter-body').id;
      const filterBodyEle = `.filters__filter-body--${triggerID}`;
      container.querySelector(filterBodyEle).classList.add('show');
    }

    const resultantContainer = target && target.querySelector('.filters-container');
    const searchContainer = target && target.querySelector('.search-results__controls');
    updateHozrontalBarToNormal(resultantContainer, trigger, null, searchContainer);
  }
}

function stickyFilterBody($currentfilter) {
  // eslint-disable-next-line jquery/no-closest
  const filterSearchContainer = $currentfilter.closest('.search-results__controls');
  let filterHeight = filterSearchContainer[0].offsetHeight;

  const appliedFilterSectionHeight = filterSearchContainer.find('.image-type-toggle-wrapper')[0] && filterSearchContainer.find('.image-type-toggle-wrapper')[0].offsetHeight;
  const isappliedFilterVisible = filterSearchContainer.find('.image-type-toggle-wrapper').width() > 1;
  if (appliedFilterSectionHeight > 1 && isappliedFilterVisible) {
    filterHeight -= appliedFilterSectionHeight;
  }
  // eslint-disable-next-line jquery/no-css
  $currentfilter.siblings().css('top', `${filterHeight}px`);
}

function updateHozrontalBarToNormal(resultantContainer, trigger, isResize, searchContainer) {
  let isDesktop = true;
  let isMobile = false;

  if (resultantContainer) {
    filterBodies = resultantContainer.querySelectorAll('.filters-resultantContainer .filters__filter-body');
    filters = resultantContainer.querySelectorAll('.filters__filter');
    dropdownBody = resultantContainer.querySelectorAll('.filters__filter-body');
    container = resultantContainer;
  }

  if (isResize && breakpoint >= 992) {
    isDesktop = false;
    if (window.innerWidth <= 991) {
      isMobile = true;
    }
  }

  if (!isLG() && isMobile) {
    filterBodies.forEach((filterBody) => {
      delete filterBody.dataset.parent;
    });
    filters.forEach((item) => {
      item.classList.add('card');
      item.classList.remove('active');
    });
    dropdownBody.forEach((dropdown) => {
      dropdown.classList.add('show');
    });
    if (isResize && container.classList.contains('show')) {
      container.classList.remove('show');
    }
    breakpoint = window.innerWidth;
  }
  if (isLG() && isDesktop) {
    if (!container.classList.contains('show')) {
      container.classList.add('show');
    }
    filterBodies.forEach((filterBody) => {
      filterBody.dataset.parent = '#filter-container-accordion';
    });
    filters.forEach((item) => {
      item.classList.remove('card');
      item.classList.remove('active');
    });
    dropdownBody.forEach((dropdown) => {
      dropdown.classList.remove('show');
    });
    if (trigger) {
      if (trigger.classList.contains('filters__value-link')) {
        const triggerID = trigger.closest('.filters__filter-body').id;
        const filterBodyEle = `.filters__filter-body--${triggerID}`;
        container.querySelector(filterBodyEle).classList.add('show');
        document.querySelector(filterBodyEle).parentElement.classList.add('active');
        stickyFilterBody($(container.querySelector(filterBodyEle).previousElementSibling));
        const isSelectedFilter = container.querySelector(filterBodyEle).querySelectorAll('.values li.selected').length > 0;
        if (isSelectedFilter) {
          container.querySelector(filterBodyEle).querySelector('.apply-button-container').classList.add('active');
        } else {
          container.querySelector(filterBodyEle).querySelector('.apply-button-container').classList.remove('active');
        }
      }
    }
    breakpoint = window.innerWidth;
    if (searchContainer) {
      StickyFilter(searchContainer, true);
    }
  }
}

window.addEventListener('resize', () => {
  if (horizontalContainer) {
    updateHozrontalBarToNormal(document.querySelector(SELECTORS.FILTERS_CONTAINER), null, true);
  }
});

export const filterVisibility = (interaction, trigger, target) => {
  const toggle = document.querySelector(SELECTORS.FILTERS_TOGGLE);
  const containers = document.querySelector(SELECTORS.FILTERS_CONTAINER);

  if (toggle && containers) {
    if ((mobileFilters(toggle) || !isLG()) && !interaction) {
      containers.classList.remove('show');
    } else {
      containers.classList.add('show');
    }
    containers.classList.remove('invisible');
  }
  if (horizontalContainer) {
    updateHorizontalFilter(trigger, target);
  }
};

/**
 * Locks the body from scrolling when the filter flyout is open.
 */
export const lockBodyScroll = () => {
  let scrollOffset;

  $(document)
    .on('shown.bs.collapse', SELECTORS.FILTERS_CONTAINER, () => {
      if (!isLG()) {
        scrollOffset = window.pageYOffset;
      }
    })
    .on('hide.bs.collapse', SELECTORS.FILTERS_CONTAINER, () => {
      if (!isLG()) {
        window.scrollTo(0, scrollOffset);
      }
    });
};

export const priceRefinement = () => {
  let { min, max } = getPriceRefinementValues();

  onEvent(document, 'focusout', SELECTORS.PRICE_REFINEMENT_INPUTS, (e) => {
    const { min: currentMin, max: currentMax } = getPriceRefinementValues();

    if (min !== currentMin || max !== currentMax) {
      const evt = new CustomEvent('submit', { bubbles: true, cancelable: true });

      e.delegateTarget.form.dispatchEvent(evt);
    }

    min = currentMin;
    max = currentMax;
  });

  // Reinit the cleaves on the price refinement fields after navigation
  [NAV_EVENTS.NAV_BACK, NAV_EVENTS.NAV_CONTENT].forEach((evt) => {
    document.addEventListener(evt, () => {
      ({ min, max } = getPriceRefinementValues());
    });
  });
};

const updateResultsCount = () => {
  const resultsCount = document.querySelector(SELECTORS.RESULTS_COUNT);
  const updatedResultsCount = document.querySelector(SELECTORS.UPDATED_RESULTS_COUNT);

  if (resultsCount && updatedResultsCount) {
    resultsCount.innerHTML = updatedResultsCount.innerHTML;

    updatedResultsCount.remove();
  }
};

const getLastProductVisitData = () => {
  const lastVisitStr = window.sessionStorage.getItem(CONSTANTS.LAST_VISITED_PRODUCT_KEY);

  if (lastVisitStr) {
    try {
      return JSON.parse(lastVisitStr);
    } catch {
      // Invalid JSON value
    }
  }

  return {};
};

export const appendProductNavHashes = () => {
  const qsInput = document.querySelector(SELECTORS.QS_INPUT);
  const qsInputValue = (qsInput && qsInput.value) || '';
  const baseHash = `#${qsInputValue.replace('?', '')}`;
  const start = parseInt(parseQueryString(qsInputValue).start, 10) || 0;

  const paged = !!document.querySelector(SELECTORS.PAGE);
  const grid = document.querySelector(SELECTORS.PRODUCT_GRID);
  const tiles = grid.querySelectorAll(SELECTORS.PRODUCT_TILE);

  // Custom start: update cloudinary responsive images
  if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
    window.makeCloudinaryImagesResponsive();
  }
  // Custom end: update cloudinary responsive images


  tiles.forEach((tile, index) => {
    const links = tile.querySelectorAll('.link');
    const pidContainer = tile.querySelector('[data-pid]');

    if (links && links.length && pidContainer) {
      const { pid } = pidContainer.dataset;

      const position = index + (paged ? start : 0);

      let tileHash = `${baseHash}&pid=${pid}&pos=${position}`;

      if (tileHash.indexOf('cgid') < 0) {
        const categoryIdInput = document.querySelector('.category-id');

        if (categoryIdInput) {
          tileHash += `&cgid=${categoryIdInput.value}`;
        }
      }

      links.forEach((link) => {
        if (link.href.indexOf('#') < 0) {
          link.href += tileHash;
        } else if (link.href.indexOf('pos=') < 0) {
          link.href += `&${tileHash.replace('#', '')}`;
        }
      });
    }
  });
};

export const plpNav = () => {
  const navConfig = [
    {
      triggerSelector: [
        SELECTORS.GRID_SIZE_SELECTOR,
        SELECTORS.FILTER_VALUE,
        SELECTORS.FILTER_RESET,
        SELECTORS.FILTER_REMOVE,
        SELECTORS.PAGE_SIZE,
        SELECTORS.SORT_OPTIONS,
        SELECTORS.PRICE_REFINEMENT_FORM,
        SELECTORS.IMAGE_TOGGLE,
      ].join(', '),
      targetSelector: SELECTORS.SEARCH_CONTENT,
      scrollTarget: SELECTORS.SEARCH_RESULTS_CONTAINER,
      paramsBlacklist: ['searchRefinement'],
      urlInputSelector: SELECTORS.URL_INPUT,
      callback: (trigger, target) => {
        const gridChange = trigger.classList.contains(CLASSES.GRID_SIZE_SELECTOR);
        const sortChange = trigger.parentElement && trigger.parentElement.classList.contains(CLASSES.SORT_OPTIONS);
        const mobileFilterRemoval = trigger.classList.contains(CLASSES.MOBILE_REFINE);
        const toggleImg = SELECTORS.IMAGE_TOGGLE.indexOf(trigger.id);
        convertSizes();
        filterVisibility(!gridChange && !sortChange && !mobileFilterRemoval && toggleImg <= 0, trigger, target);
        appendProductNavHashes();
        enableSlideonPLPAltImg();
        gtmEvents.triggerViewItemList();
        gtmEvents.triggerSortChange(sortChange, trigger);
      },
    },
    {
      triggerSelector: SELECTORS.PAGE,
      targetSelector: SELECTORS.PRODUCT_GRID,
      scrollTarget: SELECTORS.SEARCH_RESULTS_CONTAINER,
      contentKey: 'content',
      urlInputSelector: SELECTORS.URL_INPUT,
      callback: () => {
        updateResultsCount();
        appendProductNavHashes();
        enableSlideonPLPAltImg();
        gtmEvents.triggerViewItemList();
      },
    },
    {
      triggerSelector: SELECTORS.LOAD_MORE,
      targetSelector: SELECTORS.PRODUCT_GRID,
      contentKey: 'content',
      append: true,
      urlInputSelector: SELECTORS.URL_INPUT,
      callback: (trigger) => {
        trigger.closest(SELECTORS.PRODUCT_GRID_FOOTER).remove();

        updateResultsCount();
        appendProductNavHashes();
        enableSlideonPLPAltImg();
        gtmEvents.triggerViewItemList();
      },
    },
  ];

  clientSideNav(SELECTORS.SEARCH_CONTENT, navConfig);

  document.addEventListener(NAV_EVENTS.NAV_BACK, () => {
    filterVisibility();
  });

  document.addEventListener(TILE_EVENTS.ADD_TO_BAG_OVERLAY_TOGGLE, appendProductNavHashes);
};

export const scrollToProductOnBackFromPlp = () => {
  const qsInput = document.querySelector(SELECTORS.QS_INPUT) || {};
  const { cgid, q } = parseQueryString(qsInput.value || '');

  const lastVisit = getLastProductVisitData();
  const qMatch = q && lastVisit.q && q === lastVisit.q;
  const cgidMatch = cgid && lastVisit.cgid && cgid === lastVisit.cgid;
  const validOffset = lastVisit.offset && lastVisit.offset <= document.body.scrollHeight;

  if (isBackForwardNavigation() && validOffset && (qMatch || cgidMatch)) {
    scrollTo(lastVisit.offset, false);
  }

  onEvent(document, 'click', `${SELECTORS.PRODUCT_TILE} .link`, () => {
    const offset = window.pageYOffset;
    const visit = { cgid, q, offset };

    window.sessionStorage.setItem(CONSTANTS.LAST_VISITED_PRODUCT_KEY, JSON.stringify(visit));
  });

  window.sessionStorage.removeItem(CONSTANTS.LAST_VISITED_PRODUCT_KEY);
};

if (horizontalContainer) {
  $(document).on('click', '.close-horizontal-dropdown', (e) => {
    if (isLG()) {
      // eslint-disable-next-line jquery/no-closest
      const $parentDiv = $(e.currentTarget.parentElement.parentElement);
      // eslint-disable-next-line jquery/no-find
      const toggleButton = $parentDiv.find('.filters__toggle-section__btn-icon');
      // Trigger a click on the toggle button

      if (toggleButton.length) {
        toggleButton.trigger('click');
      }
    }
  });

  $(document).on('click', '.apply-button', (e) => {
    if (isLG() && horizontalContainer && e.currentTarget.parentElement.classList.contains('active')) {
      // Scroll to the top of the grid
      const elements = {
        grid: document.querySelector('.row.product-grid-wrapper'),
        controls: document.querySelector('.row.search-results__controls'),
        header: document.querySelector('.compact-header'),
      };

      if (elements.grid && elements.controls && elements.header) {
        const scrollPosition = elements.grid.getBoundingClientRect().top + window.pageYOffset - (elements.header.offsetHeight + elements.controls.offsetHeight);
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      }
      // eslint-disable-next-line jquery/no-closest
      const $parentDiv = $(e.currentTarget).closest('.filters__toggle-section ');
      // eslint-disable-next-line jquery/no-find
      const toggleButton = $parentDiv.find('.filters__toggle-section__btn-icon');
      // Trigger a click on the toggle button

      if (toggleButton.length) {
        toggleButton.trigger('click');
      }
    }
  });

  $(document).on('click', '.filters__toggle-section__btn', (e) => {
    if (isLG() && horizontalContainer) {
      const $currentfilter = $(e.currentTarget);
      stickyFilterBody($currentfilter);
      const $allfilters = $('.filters-container .filters__toggle-section__btn');
      // eslint-disable-next-line jquery/no-class, jquery/no-parent
      $allfilters.not($currentfilter).parent().removeClass('active');
      // eslint-disable-next-line jquery/no-class, jquery/no-find, jquery/no-parent
      $allfilters.not($currentfilter).parent().find('.filters__filter-body').removeClass('show');
      const isSelectedFilter = e.currentTarget.parentElement.querySelector('.filters__filter-body').querySelectorAll('.values li.selected').length > 0;
      const { min, max } = getPriceRefinementValues();
      const isPriceFilter = (min !== '' || max !== '') && e.currentTarget.parentElement.classList.contains('filters__filter--price');
      if (isSelectedFilter || isPriceFilter) {
        e.currentTarget.parentElement.querySelector('.filters__filter-body').querySelector('.apply-button-container').classList.add('active');
      } else {
        e.currentTarget.parentElement.querySelector('.filters__filter-body').querySelector('.apply-button-container').classList.remove('active');
      }
    }
  });

  $(document).on('click', '.show-more-container', () => {
    if ($('.show-more-container').text() === 'Show more') {
      // eslint-disable-next-line jquery/no-class
      $('.show-less').addClass('show-more').removeClass('show-less');
      $('.show-more-container').text('Show less');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.show-more').addClass('show-less').removeClass('show-more');
      $('.show-more-container').text('Show more');
    }
  });
}

$(document).on('click', (event) => {
  if (isLG() && horizontalContainer && event.target) {
    const $toggleBtn = $('.filters__toggle-section__btn');
    const $toggleButton = $('.filters__toggle-section__btn-icon');
    const $dropdownBody = $('.filters__filter-body.show');
    // eslint-disable-next-line jquery/no-closest
    if (!$(event.target).closest($toggleButton).length && !$(event.target).closest($toggleBtn).length && !$(event.target).closest($dropdownBody).length && event.target.className.indexOf('filters__filter-header__text') === -1) {
      if ($('.filters__body .filters__filter.active')) {
        // eslint-disable-next-line jquery/no-trigger, jquery/no-find
        $('.filters__body .filters__filter.active').find('.filters__toggle-section__btn-icon').trigger('click');
      }
    }
  }
});

$(document).on('input', '.filters__input--price', (e) => {
  if (isLG() && horizontalContainer && e.currentTarget) {
    // eslint-disable-next-line jquery/no-closest
    const filterBody = $(e.currentTarget).closest('.filters__filter-body');
    const applyButton = filterBody && filterBody.find('.apply-button-container');

    const { min, max } = getPriceRefinementValues();
    if (min !== '' || max !== '') {
      applyButton.addClass('active');
    } else {
      applyButton.removeClass('active');
    }
  }
});

function stickyFilterAction(searchContainer) {
  const $header = $('.compact-header');
  let $plpFilter = $('.horizontal-container .search-results__controls');

  if (searchContainer) {
    $plpFilter = $(searchContainer);
  }

  let headerHeight = $header.outerHeight();
  // Update the header height on resize
  if ($(window).width() > 991) {
    headerHeight = $header.outerHeight();
  }

  if (window.scrollY > headerHeight && $(window).width() > 991) {
    // eslint-disable-next-line jquery/no-css, jquery/no-class
    $plpFilter.addClass('sticky').css('top', `${headerHeight}px`);
  } else {
    // eslint-disable-next-line jquery/no-css, jquery/no-class
    $plpFilter.removeClass('sticky').css('top', '0');
  }
}

function StickyFilter(searchContainer, isAppliedFilter) {
  if (isAppliedFilter) {
    stickyFilterAction(searchContainer);
  } else {
    $(document).on('scroll resize', () => {
      stickyFilterAction(searchContainer);
    });
  }
}

export const hideFilterBodyOnScroll = () => {
  let isFilters = document.querySelector('.filters__body .filters__filter.active');
  if (isLG() && horizontalContainer && isFilters) {
    const isSelectedFilter = isFilters.querySelectorAll('.values li.selected').length > 0;
    isFilters = $(isFilters);

    if (isFilters && !isSelectedFilter) {
      // eslint-disable-next-line jquery/no-trigger, jquery/no-find
      isFilters.find('.filters__toggle-section__btn-icon').trigger('click');
    }
  }
};

const scrollThrottle = throttle(hideFilterBodyOnScroll, 150);
if (horizontalContainer) {
  window.addEventListener('scroll', scrollThrottle);
}

$(document).ready(() => {
  gtmEvents.triggerViewItemList();
  if (horizontalContainer) {
    StickyFilter();
  }
});

export const initSizeConversions = convertSizes;
